export default {
  toLogin: '前往登录',
  beforeLogin: '请您先登录',
  personalCenter: '个人中心',
  dataModification: '资料修改',
  mail: '站内信 ',
  applyJoin: '申请入会'
  // 可以继续添加其他翻译
};
